"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migration_75_0_0 = void 0;
/**
 * Migrate to 75.0.0
 *
 * Rename e-spool to espool / ESpool to Espool
 *
 */
const migration_75_0_0 = (json) => {
    const espool = json.ESpool;
    if (espool) {
        json.Espool = espool;
        delete json.ESpool;
    }
    return json;
};
exports.migration_75_0_0 = migration_75_0_0;
//# sourceMappingURL=migration_75_0_0.js.map